import script from "./FranchiseSyncOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseSyncOverview.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseSyncOverview.vue?vue&type=style&index=0&id=4f182d5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f182d5f"]])

export default __exports__